import { ZoneType } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

/** Zone types are few (a handful per database); one `Get` covers them. */
const ZONE_TYPES_LIMIT = 1000;

export function useZoneTypes() {
  const { geotabClient, activeSessionId } = useGeotabClient();

  return useQuery({
    queryKey: ["zoneTypes", activeSessionId],
    queryFn: ({ signal }) =>
      geotabClient.call<ZoneType[]>("Get", { typeName: "ZoneType", resultsLimit: ZONE_TYPES_LIMIT }, signal),
  });
}
